import React from 'react'

interface GenericCardFooterProps {
  children?: React.ReactNode
}

export const GenericCardFooter: React.FC<GenericCardFooterProps> = ({
  children
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
      }}
    >
      {children}
    </div>
  )
}
